import { Box, Button, CircularProgress, Input, Menu, SelectChangeEvent, TextareaAutosize, Tooltip, Typography } from '@mui/material';
import React, { ChangeEvent, useState } from 'react';
import { AlertType } from '../DataGrid/MuiDataGrid';
import CommentIcon from '@mui/icons-material/Comment';
import { getStyles } from '../DataGrid/MuiDataGridStyle';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { sendNotification, updateMyteam } from '../../services/myTeamService';
import { useDispatch } from 'react-redux';
import { updateReport } from '../../redux-toolkit/reducers/reportsReducer';
import { User } from '../../redux-toolkit/reducers/userReducer';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-toolkit/store/stateType';
import { useTheme } from '@emotion/react';



export interface Project {
  'startDate': number;
  'Feature': string;
  'Category': string;
  'WorkItem': string,
  'Duration': number,

}
const Styles = {
  userMenuTopMargin: {
    marginTop: 'auto'
  }
};

type ThreeDotsMyTeamProps = {
  value: any,
  setShowAlert: React.Dispatch<React.SetStateAction<AlertType | undefined>>,
  setWarningMessage: any
};
const ThreeDotMyTeamAction = ({ value, setShowAlert }: ThreeDotsMyTeamProps) => {
  const [values, setValues] = useState(value.row);
  const theme = useTheme();
  const Style = getStyles(theme);
  const [moreDetailsDialogue, setMoreDetailsDialogue] = React.useState<null | HTMLElement>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [comments, setComment] = useState('');
  const [reportId, setReportId] = useState('');
  const dispatch = useDispatch();
  const user: User = useSelector((state: RootState) => state.user);

  const initialValue = {
    startDate: values.activityDate,
    Feature: values.feature,
    Category: values.activityType,
    Duration: values.activityDuration,
    WorkItem: values.workDescription,
    email: values.email,
    projectName: values.projectName,
    reportId: values.reportId,
    comment: values.comments,
    userName: values.userName,
		worFromHome: values.worFromHome,
  };
  const [rowValue, setRowValue] = useState(initialValue);

  const handleOpenMoreDetails = (event: React.MouseEvent<HTMLElement>) => {
    setReportId(rowValue.reportId);
    setMoreDetailsDialogue(event.currentTarget);

  };

  const handleCloseNotification = () => {
    setMoreDetailsDialogue(null);
  };


  const handleAddComment = (event: any) => {
    const { value, name } = event.target;
    setRowValue({
      ...rowValue,
      [name]: value
    });
  };

  const handleAddProject = async () => {
    setIsLoading(true);

    try {
      const response = await updateMyteam(rowValue, reportId);
      const { data } = response.data;
      showNotification(rowValue);

      const changedReport = {
        comments: data.comments,
        reportId: data.reportId,
      };

      dispatch({
        type: updateReport,
        payload: changedReport,
      });

      setIsLoading(false);
      setMoreDetailsDialogue(null);
    } catch (error) {
      setIsLoading(false);

    }
  };

  const showNotification = async (notifications: any) => {

    try {
      const currentUser = user.firstName + ' ' + user.lastName;
      const startDate = new Date(notifications.startDate);
      const formattedStartDate = startDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit', year: 'numeric' });
      const response = await sendNotification(formattedStartDate, notifications, currentUser);
      console.log(response, 'response');
    } catch (error) {
      console.log(error, 'error');
    }
  };


  const handleCloseNewProject = () => {
    setMoreDetailsDialogue(null);
  };


  return (
    <Box>
      <Box display={'flex'} alignItems='center' justifyContent={'space-between'}>
        <Button onClick={handleOpenMoreDetails}>
          <Tooltip title="Add comment">
            <CommentIcon style={{ color: 'grey' }} />
          </Tooltip>

        </Button>
      </Box>
      <Box>
        <Menu
          sx={Styles.userMenuTopMargin}
          id="menu-appbar"
          anchorEl={moreDetailsDialogue}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={Boolean(moreDetailsDialogue)}
          onClose={handleCloseNotification}
        >
          <Box sx={Style.popupContentBox}>
            <Typography style={Style.newRowTitle}> StartDate</Typography>
            <Box sx={Style.calenderContainer}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  readOnly
                  PopperProps={{
                    popperOptions: {
                      placement: 'right-end'
                    }
                  }}
                  value={rowValue.startDate ? new Date(rowValue.startDate) : null}
                  onChange={(newValue: any) => {
                    setRowValue({
                      ...rowValue,
                      startDate: newValue ? `${new Date(newValue.toDate())}` : rowValue.startDate
                    });
                  }}
                  disableFuture={true}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <Box sx={Style.calenderInputContainer}>
                      <input style={Style.calenderInput} ref={inputRef} {...inputProps} />
                      {InputProps?.endAdornment}
                    </Box>
                  )}
                />
              </LocalizationProvider>
            </Box>
            <Box>
              <Typography style={Style.newRowTitle}>Feature</Typography>
              <Input
                id="Feature"
                name='Feature'
                readOnly
                type='text'
                multiline={false}
                disableUnderline
                value={rowValue.Feature}
                sx={Style.input}

              />
            </Box>
            <Box>
              <Typography style={Style.newRowTitle}>Category</Typography>
              <Input
                id="Category"
                name='Category'
                readOnly
                type='text'
                multiline={false}
                disableUnderline
                value={rowValue.Category}
                sx={Style.input}
              />
            </Box>
            <Box>
              <Typography style={Style.newRowTitle}>Work Item</Typography>
              <TextareaAutosize
                id="WorkItem"
                name='WorkItem'
                readOnly
                style={Style.textarea} minRows={5}
                value={rowValue.WorkItem}
              />
            </Box>
            <Box>
              <Typography style={Style.newRowTitle}>Duration</Typography>
              <Input
                id="Duration"
                name='Duration'
                readOnly
                type='text'
                multiline={false}
                disableUnderline
                value={rowValue.Duration}
                sx={Style.input}

              />
            </Box>
            <Box>
              <Typography style={Style.newRowTitle}>Comment</Typography>
              <TextareaAutosize
                id='Comment'
                name='comment'
                value={rowValue.comment}
                style={Style.textarea} minRows={5}
                onChange={handleAddComment}
              />
            </Box>
            <Box sx={Style.buttonContainer}>
              <Button
                size='small'
                variant='contained'
                color="secondary"
                style={Style.newRowButton}
                onClick={handleAddProject}
                disabled={isLoading}
                endIcon={isLoading ? < CircularProgress color="success" style={Style.progress} /> : null}>
                Save
              </Button>
              <Button
                onClick={handleCloseNewProject}
                size='small'
                variant="outlined"
                style={Style.newRowButton}>Cancel</Button>
            </Box>
          </Box>

        </Menu>

      </Box>
    </Box>
  );
};

export default ThreeDotMyTeamAction;
